/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { CommandMenuItemConfig } from '@veeam/components';
import type { ButtonTypeItem, ToolbarCanAction } from '@veeam/components/lib/Toolbar/types';

import { SelectionMode } from '../../Grid/enums';

export const processItems = (
    items: CommandMenuItemConfig[],
    selectedItems: unknown[],
    selectionMode: SelectionMode,
    loading: boolean,
    canAction: ToolbarCanAction,
): CommandMenuItemConfig[] => {
    const payload = {
        selectedItems: selectedItems as Record<string, unknown>[],
        flags: {
            isAllPageMode: selectionMode === SelectionMode.AllPages,
        },
        loading,
    };

    const actions = items.map((itemProps, index) => {
        if (!itemProps) {
            return null;
        }

        const { decorators = [] } = itemProps as unknown as ButtonTypeItem;

        const decoratedProps = { disabled: false, hidden: false };

        decorators.forEach((curr) => {
            const { disabled, hidden } = curr(payload || {}, { canAction }) || {};

            decoratedProps.disabled = decoratedProps.disabled || (payload && payload.loading ? true : disabled);
            decoratedProps.hidden = decoratedProps.hidden || hidden;
        });

        return {
            ...itemProps,
            ...decoratedProps,
            id: itemProps.id || itemProps.text || `item-${index}`,
            items: itemProps.items && processItems(itemProps.items, selectedItems, selectionMode, loading, canAction),
        };
    });

    return actions;
};
